import React from 'react';
import { Route } from 'react-router-dom';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';
import { isCordova } from 'utils/platform';

const AsyncMessagesPage = Load(() => import(/* webpackChunkName: "chat2" */'./components/MessagesPage'));
const AsyncSchedulePage = Load(() => import(/* webpackChunkName: "chat2" */'./components/SchedulePage'));
const AsyncArchivedBookingsPage = Load(() => import(/* webpackChunkName: "chat2" */'./components/ArchivedBookingsPage'));
const AsyncActionPage = Load(() => import(/* webpackChunkName: "chat2" */'./components/ActionPage'));
const AsyncBookingDetailsPage = Load(() => import(/* webpackChunkName: "chat2" */'./components/BookingDetailsPage'));

const UserEnvironment2Routes = [
  <NavigationableLayout
    hideFooter
    key="message"
    path={`${basePath}/messages`}
    showBottomNavigation
    noNavbar={isCordova()}
    component={AsyncMessagesPage}
    showZendesk={false}
  />,
  <NavigationableLayout
    hideFooter
    key="action"
    path={`${basePath}/action`}
    showBottomNavigation
    noNavbar={isCordova()}
    component={AsyncActionPage}
    showZendesk={false}
  />,
  <NavigationableLayout
    hideFooter
    key="schedule"
    path={`${basePath}/schedule`}
    showBottomNavigation
    noNavbar={isCordova()}
    component={AsyncSchedulePage}
    showZendesk={false}
  />,
  <NavigationableLayout
    hideFooter
    key="schedule"
    path={`${basePath}/archived-bookings`}
    showBottomNavigation
    noNavbar={isCordova()}
    component={AsyncArchivedBookingsPage}
    showZendesk={false}
  />,
  <Route
    key="booking-details"
    path={`${basePath}/booking-details/:bookingId`}
  >
    <AsyncBookingDetailsPage />
  </Route>
];

export default UserEnvironment2Routes;
